export const OFFLINE_FEED_QUEUE_KEY = 'y-feed-offline-queue';

function resolveStorage(preferred) {
  if (preferred) return preferred;
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  return null;
}

export function readQueue(storage) {
  const resolved = resolveStorage(storage);
  if (!resolved) return [];
  try {
    const raw = resolved.getItem(OFFLINE_FEED_QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

export function writeQueue(queue, storage) {
  const resolved = resolveStorage(storage);
  if (!resolved) return;
  const payload = Array.isArray(queue) ? queue : [];
  resolved.setItem(OFFLINE_FEED_QUEUE_KEY, JSON.stringify(payload));
}

export function enqueueOfflineEvent({ storage, target, payload }) {
  if (!target || !target.kind || !target.id) return readQueue(storage);
  const event = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    target,
    payload,
    createdAt: new Date().toISOString()
  };
  const queue = [...readQueue(storage), event];
  writeQueue(queue, storage);
  return queue;
}

export async function flushQueue({ storage, sendFn }) {
  if (typeof sendFn !== 'function') {
    return { flushed: 0, remaining: readQueue(storage).length };
  }
  const pending = readQueue(storage);
  if (pending.length === 0) return { flushed: 0, remaining: 0 };
  const remaining = [];
  for (const event of pending) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await sendFn(event);
    } catch (err) {
      remaining.push(event);
    }
  }
  writeQueue(remaining, storage);
  return { flushed: pending.length - remaining.length, remaining: remaining.length };
}

export function clearQueue(storage) {
  const resolved = resolveStorage(storage);
  if (!resolved) return;
  resolved.removeItem(OFFLINE_FEED_QUEUE_KEY);
}

const offlineFeedQueue = {
  OFFLINE_FEED_QUEUE_KEY,
  readQueue,
  writeQueue,
  enqueueOfflineEvent,
  flushQueue,
  clearQueue
};

export default offlineFeedQueue;

